import {
  imprimirServicoAntigo,
  imprimirServicoNovo,
  buscarDadosImpressao,
} from '../utils';
import adapter from './adapter';
import layout from './layout';
import adapterComprovante from '../comprovanteTef/adapter';
import layoutComprovante from '../comprovanteTef/layout';
import { imprimirNotaVenda} from 'modulo-gerencial-erp-pacotes-impressora-termica'

async function imprimir(id, query = '', usar_nova_impressao = false, comprovantes) {
  /* if (!usar_nova_impressao) {
    return await imprimirServicoAntigo(id, 1, query);
  }

  const dados = await buscarDadosImpressao(id, 1);

  const { comandos: comandosVenda } = layout(adapter(dados));

  let comandos = [...comandosVenda]

  for(let i = 0; i < comprovantes.length; i++) {
    const { comandos: comandosComprovante } = layoutComprovante(adapterComprovante(comprovantes[i]));
    comandos = [...comandos, ...comandosComprovante]
  }

  const response = await imprimirServicoNovo(id, 'venda', comandos);
  return response.data; */

  return await imprimirNotaVenda({id, buscarDadosImpressao, chamarServicoImpressoraTermica: imprimirServicoNovo, comprovantes, query: ''})
}

export default imprimir;
